import ProjectListItem from "./ProjectListItem";
import "../../../styles/Projects.css";
import projects from "./ProjectJSON";
import { v4 as uuidv4 } from "uuid";

const Projects = () => {
  return (
    <section tabIndex="0" id="projects" className="projects">
      <div className="projects__intro">
        <h2>Projects</h2>
        <div className="underline">
          <div className="heading-underline"></div>
          <div className="heading-underline-end"></div>
        </div>
      </div>
      <ul className="projects__container">
        {projects.map((project) => {
          const uniqueKey = uuidv4();

          return (
            <ProjectListItem
              key={uniqueKey}
              img={project.img}
              class={project.class}
              description={project.description}
              id={project.id}
              url={project.url}
              tags={project.tags}
              project={project.project_name}
            />
          );
        })}
      </ul>
    </section>
  );
};

export default Projects;
